<template>
    <div class="fill-height">
		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400px">
			<v-card>
				<!-- <div class="d-flex justify-end "> -->
				<v-card-title class="pt-3 pb-1">Delete employee</v-card-title>
				<!-- </div> -->

				<v-card-text class="pt-2 pb-0">
					Are you sure you want to delete this Task ?
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn
						color="alert-color white--text"
						class="rounded-lg text-none"
						:loading="loadingDelete || loading"
						@click="deleteTask()"
					>
						Yes
					</v-btn>

					<v-btn
						@click="deleteDialog = false"
						:disabled="loadingDelete || loading"
						text
						class="text-none rounded-lg"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-row v-if="0" class="pt-4">
			<v-spacer />
			<v-col cols="3" align-self="center" class="py-1 d-flex justify-end">
				<v-btn
					color="green-color white--text"
					:to="{ name: 'add-papper-task' }"
					:disabled="loading"
					class="text-none rounded-lg"
				>
					Add New task
				</v-btn>
            </v-col>
		</v-row>
        <!-- filter -->
        <v-row class="my-1">
            <v-col cols="6" sm="4" md="3" align-self="center" class="py-1 px-1 d-flex">
				<v-checkbox 
					v-model="allUsers" 
					label="All" 
					class="me-3 my-0" 
					hide-details 
				/>

				<v-autocomplete
					v-model="employeeName"
					:items="usersWithoutPag"
					:item-text="(item) => `${item.employee?.arabicFirstName}` + ' ' + `${item.employee?.arabicLastName}`"
					item-value="id"
					dense
					label="Employee"
					hide-details
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input rounded-lg"
					:loading="loading || userLoading"
					:disabled="loading"
					multiple
					clearable
				>
					<template v-slot:selection="{ item, index }">
						<span v-if="index === 0" class="me-1">
							{{ item.employee?.arabicFirstName + ' ' + item.employee?.arabicLastName }}
						</span>
						<span
							v-if="index === 1"
							class="text--color text-caption"
						>
							(+{{ employeeName.length - 1 }})
						</span>
					</template>  
				</v-autocomplete>
            </v-col>
			<v-divider vertical class="mx-2 my-2" />
			<v-col cols="auto" align-self="center" class="py-1 px-1">
				<v-radio-group v-model="typeDate" row hide-details class="mt-0">
					<v-radio label="Daily" :value="1"></v-radio>
					<v-radio label="Custom" :value="2"></v-radio>
				</v-radio-group>
			</v-col>

			<v-col v-if="typeDate === 1" cols="3" align-self="center" class="py-1 px-1">
				<bee-date-input
					v-model="DateByDay"
					append-icon="mdi-menu-right"
					@click:append="upDay(); isSearch = true; fetchTasks()"
					prepend-icon="mdi-menu-left"
					@click:prepend="downDay();isSearch = true; fetchTasks()"
					:label="moment(DateByDay).format('dddd') "
					input-format-order="DD-MM-YYYY"
					dense
					class="rounded-lg"
					hide-details
				></bee-date-input>
            </v-col>

            <v-col v-if="typeDate === 2" cols="6" sm="4" md="3" align-self="center" class="py-1 px-1">
				<bee-date-input
					v-model="fromDate"
					append-icon="mdi-menu-right"
					@click:append="upDay()"
					prepend-icon="mdi-menu-left"
					@click:prepend="downDay()"
					label="Start date"
					input-format-order="DD-MM-YYYY"
					dense
					class="rounded-lg"
					hide-details
				></bee-date-input>
            </v-col>
            <v-col v-if="typeDate === 2" cols="6" sm="4" md="3" align-self="center" class=" py-1 px-1">
				<!-- pb-sm-0 pb-md-2	 -->
				<bee-date-input
					v-model="toDate"
					append-icon="mdi-menu-right"
					@click:append="upToDate()"
					prepend-icon="mdi-menu-left"
					@click:prepend="downToDate()"
					label="End date"
					input-format-order="DD-MM-YYYY"
					dense
					hide-details
					:disabled="loading"
					:loading="loading"
					class="rounded-lg"
				></bee-date-input>
            </v-col>

			<!-- projects -->
			<v-col cols="3" align-self="center" class="py-1 px-1">
				<v-autocomplete
					v-model="projects"
					:items="projectsBrief"
					item-text="name"
					item-value="id"
					label="Projects"
					dense
					hide-details
					multiple
					:disabled="loading"
					:loading="loading"
					clearable
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input rounded-lg"
				>	
					<template v-slot:selection="{ item, index }">
						<span v-if="index === 0" class="me-1">{{ item.name }}</span>
						<span
							v-if="index === 1"
							class="text--color text-caption"
						>
							(+{{ projects.length - 1 }})
						</span>
					</template>  
				</v-autocomplete>
			</v-col>

			<!-- no -->
			<v-col cols="1" align-self="center" class="py-1 px-1">
				<v-text-field
					v-model.number="no"
					label="Task no"
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input rounded-lg"
					dense
					hide-details
					type="number"
					hide-spin-buttons
					:disabled="loading"
					:loading="loading"
				/>
			</v-col>

			<!-- description -->
			<v-col cols="3" align-self="center" class="py-1 px-1">
				<v-textarea 
					v-model="description"
					label="Description" 
					class="input rounded-lg"
					dense
					hide-details 
					rows="1"
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					:disabled="loading"
					:loading="loading"
				/>
			</v-col>

			<!--  -->

			<v-col v-if="0" cols="6" sm="6" md="3" class="py-1 d-flex align-center ">
				<v-text-field 
					label="search"
					v-model="keyWord"
					dense
					outlined
					filled
					hide-details
					append-icon="mdi-magnify"
					@keypress.enter="search()"
					disabled
					class="rounded-lg"
				/>
				<!-- <v-btn class="mx-2" color="success"> search </v-btn> -->
			</v-col>

            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp" /> -->

            <v-col cols="6" sm="3" class="d-flex justify-md-start mb-sm-2 mb-md-0 py-1 px-1" align-self="center" >
				<v-btn
					@click="isSearch=true; fetchTasks()"
					color="dark-blue white--text"
					:loading="loading"
					class="mx-2 rounded-lg text-none"
				>
					Search
				</v-btn>

				<v-btn
					@click="reset()"
					color="alert-color white--text"
					:loading="loading"
					:disabled="loading"
					class="mx-2 rounded-lg text-none"
				>
					Cancel
				</v-btn>

            </v-col>
			<v-spacer />
			<v-col class="d-flex justify-end">
				<v-divider vertical class="me-2 ms-1" />
				<v-btn
					color="green-color white--text"
					:to="{ name: 'add-papper-task' }"
					:disabled="loading"
					class="text-none rounded-lg"
				>
					Add New task
				</v-btn>
			</v-col>
        </v-row>
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			dense
			zebra
			:height="$vuetify.breakpoint.height - 260"
			fixed-header
			:loading="loading"
			pagination-on-scroll
			pagination-on-scroll-server-items
			:options-scroll.sync="optionsScroll"
			:pagination-on-scroll-auto-reset-shown="false"
			:server-items-length="serverItemsLength"
			:items-per-page="20"
			@pagination-on-scroll:reach-last-row="fetchTasks"
			table-class="elevation-0"
			class="mt-0"
		>
			<template v-slot:item.user="{ item }">
				<span class="zain-regular"> 
					{{ getUserWithoutPagById(item.userId)?.employee.arabicFirstName + ' ' + getUserWithoutPagById(item.userId)?.employee.arabicLastName }} 
				</span>
			</template>

			<template v-slot:item.actions="{ item }">
				<v-btn
					small
					class=""
					icon
					:to="{ name: 'add-papper-task', params: { id: item.id } ,query: { preview: true } }"
				>
					<v-icon color="dark-blue">
						mdi-eye-outline
					</v-icon>
				</v-btn>

				<v-btn
					icon
					small
					color="alert-color"
					@click="deleteItemId = item.id; deleteDialog = true"
				>
					<v-icon> mdi-delete </v-icon>
				</v-btn>
			</template>
		</bee-handy-table>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar" :color=" success ? 'secondary' : 'alert-color'">
			{{message}}
			<template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
export default {
	watch: {
		allUsers (val) {
			this.userLoading = true
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: !val }).finally(() => {
				this.userLoading = false
			})
		} 
	},
	data () {
		return {
			day: '',
			fromDate: moment(moment().startOf('month')).format('YYYY-MM-DD'),
			toDate: moment().format('YYYY-MM-DD'),
			employeeName: [],
			loading: false,
			loadingDelay: 1000,
			optionsScroll: {},
			serverItemsLength: 0,
			totalWorkDay: null,
			workDaysss: [{ id: 1, user: 'user', date: '1-1-2023', enter_time_formatted: '12:00pm', leave_time_formatted: '1:00pm', duration: '', actual_duration: '', variance: '' }],
			isSearch: false,
			deleteDialog: false,
			deleteItemId: null,
			loadingDelete: false,
			keyWord: null,
			snackbar: false,
			message: false,
			success: false,
			projects: [],
			no: null,
			description: null,
			typeDate: 1,
			DateByDay: moment().format('YYYY-MM-DD'),
			allUsers: false,
			userLoading: false
		}
	},
	computed: {
		...mapState({
			usersWithoutPag: state => state.users.usersWithoutPag,
			projectsBrief: state => state.projects.projectsBrief
		}),

		...mapGetters({
			// getUserById: 'users/getUserById'
			getUserWithoutPagById: 'users/getUserWithoutPagById'
		}),

		headers () {
			return [
				// { 
				// 	text: '#', 
				// 	value: 'id', 
				// 	name: 'id',
				// 	setValueExpr: (index, val) => { return index },
				// 	align: 'center'
				// },
				{ 
					text: 'Beetronixer', 
					name: 'user',
					value: 'userId', 
					align: 'center' 
				},
				{ 
					text: 'work day', 
					value: 'date', 
					name: 'date',
					setValueExpr: val => this.moment(val).format('YYYY-MM-DD'),
					align: 'center',
					width: '10%'
				},
				{
					text: 'Check in', 
					name: 'checkIn', 
					value: 'startDate', 
					noNotAvailableText: true,
					setValueExpr: val => val ? this.moment(val).format('hh:mm a') : '-',
					align: 'center',
					classCell: 'font-weight-bold',
					columnClass: 'font-weight-bold'
				},

				{
					text: 'Check out', 
					name: 'checkOut', 
					value: 'endDate', 
					noNotAvailableText: true,
					setValueExpr: val => val ? this.moment(val).format('hh:mm a') : '-',
					align: 'center' 
				},

				{ 
					text: 'Span', 
					name: 'actual_duration',
					value: 'workTime', 
					setValueExpr: val => {
						if (val !== null) {
							const hoursDifference = val / 60; 
							return `${Math.floor(hoursDifference)}:${Math.floor((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
						} else {
							return '-'
						}
					},
					noNotAvailableText: true,
					align: 'center' 
				},

				{ 
					text: 'Enter Time', 
					name: 'enter_time_formatted', 
					value: 'enterTime', 
					noNotAvailableText: true,
					setValueExpr: val => val ? this.moment(val).format('hh:mm a') : '-',
					align: 'center',
					columnClass: 'font-weight-bold'
				},
				{ 
					text: 'Leave Time', 
					name: 'leave_time_formatted', 
					value: 'leaveTime', 
					noNotAvailableText: true,
					setValueExpr: val => val !== null ? moment(val).format('hh:mm a') : '-',
					align: 'center' 
				},
				{ 
					text: 'Attendance', 
					name: 'duration', 
					value: 'officeHours', 
					noNotAvailableText: true,
					setValueExpr: val => {
						const hoursDifference = val / 60; 
						return `${Math.floor(hoursDifference)}:${Math.floor((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
					},
					align: 'center',
					columnClass: 'font-weight-bold'
				},
		
				{
					text: 'Tasks',
					name: 'actual_duration',
					value: 'actualWorkTime',
					setValueExpr: val => {
						if (val > 0) {
							const hoursDifference = val / 60; 
							return `${Math.floor(hoursDifference)}:${Math.floor((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
						} else {
							return '-'
						}
					},
					columnClass: 'font-weight-bold'
				},
				{ 
					text: 'Variance', 
					name: 'variance', 
					value: 'variance', 
					setValueExpr: val => val > 0 ? (val / 60).toFixed(2) : '-',
					// setValueExpr: val => {
					// 	if (val > 0) {
					// 		const hoursDifference = val / 60; 
					// 		return `${Math.floor(hoursDifference)}:${((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(2)}`
					// 	} else {
					// 		return '-'
					// 	}
					// },
					align: 'center' 
				},
				{ text: 'actions', name: 'actions', value: 'actions' }
			]
		} 
	},
	methods: {
		fetchTasks (newOptionsScroll) {
			let page = 1;
			if (newOptionsScroll) {
				page = newOptionsScroll.page
			}
			const { itemsPerPage } = this.optionsScroll;
			this.loading = true
			this.$store.dispatch('workDay/fetchAll', {
				fromDate: this.typeDate === 1 ? moment(this.DateByDay).format('YYYY-MM-DD') : this.fromDate, 
				toDate: this.typeDate === 1 ? moment(this.DateByDay).format('YYYY-MM-DD') : this.toDate,
				projectIds: this.projects, 
				taskNo: this.no, 
				content: this.description, 
				// tags, 
				userIds: this.employeeName.length ? this.employeeName : [], 
				// workdayIds, 
				// approved, 
				Page: page, 
				PerPage: 20
			}).then((data) => {
				if (this.isSearch) {
					this.$refs.table.resetShownRows()
				}
				this.$refs.table.addScrollItems(data.data);        
				
				this.serverItemsLength = data.total
			}).finally(() => {
				this.loading = false
				this.isSearch = false
			})
		},

		moment,
		upDay () {
			if (this.typeDate === 2) {
				this.fromDate = this.moment(this.fromDate).add(1, 'day').format('YYYY-MM-DD')
				return this.fromDate
			} else {
				this.DateByDay = this.moment(this.DateByDay).add(1, 'day').format('YYYY-MM-DD')
				return this.DateByDay
			}
		},

		downDay () {
			if (this.typeDate === 2) {
				this.fromDate = this.moment(this.fromDate).subtract(1, 'day').format('YYYY-MM-DD')
				return this.fromDate
			} else {
				this.DateByDay = this.moment(this.DateByDay).subtract(1, 'day').format('YYYY-MM-DD')
				return this.DateByDay
			}
		},

		upToDate () {
			this.toDate = this.moment(this.toDate).add(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},

		downToDate () {
			this.toDate = this.moment(this.toDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},

		reset () {
			this.isSearch = false
			this.employeeName = []
			this.projects = []
			this.fromDate = moment(moment().startOf('month')).format('YYYY-MM-DD')
			this.taskNo = null
			this.toDate = moment().format('YYYY-MM-DD')
			this.fetchTasks()
		},

		deleteTask () {
			this.loadingDelete = true
			this.$store.dispatch('workDay/delete', { id: this.deleteItemId }).then(() => {
				this.$refs.table.resetShownRows()
				this.fetchTasks()
			}).then(() => {
				this.snackbar = true
				this.message = 'A workday has been successfully deleted'
				this.success = true
			}).catch(() => {
				this.snackbar = true
				this.message = 'Deletion operation failed'
			}).finally(() => {
				this.loadingDelete = false
				this.deleteDialog = false
			})
		}
	},

	mounted () {
		this.loading = true;
		Promise.all([
			this.fetchTasks(),
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }),
			// this.$store.dispatch('projects/fetchAll', { CategoryIds: [], UserId: [] }),
			!this.projectsBrief.length ? this.$store.dispatch('projects/fetchProjectBrief') : null
		]).finally(() => {
			this.loading = false
		})	
	}

}
</script>
